/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, number, bool, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";

const RequestCacSummaryBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const {
        numeroEcheq = props.numeroEcheq,
        montoTotal = props.montoTotal,
        curency = props.curency,
        idEcheq = props.idEcheq,
        caracter = props.caracter,
        document = props.document,
    } = data;

    return (
        <GridTable className="deposit-summary form-summary">
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData titleText="echecks.id.label" titleTextType="I18N" valueText={idEcheq} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.cuil.label" titleTextType="I18N" valueText={document} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText=" echecks.currency" titleTextType="I18N" valueText={curency} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.number.label" titleTextType="I18N" valueText={numeroEcheq} />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.monto.total"
                        titleTextType="I18N"
                        valueText={<FormattedAmount className="data-label" currency={curency} quantity={montoTotal} />}
                    />
                </GridTable.Data>
                <GridTable.Data>
                    <CustomData titleText="echecks.character" titleTextType="I18N" valueText={caracter} />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable>
    );
};

RequestCacSummaryBody.propTypes = {
    numeroEcheq: string,
    montoTotal: number,
    curency: string,
    idEcheq: string,
    caracter: string,
    document:string,
};

RequestCacSummaryBody.defaultProps = {
    numeroEcheq: "",
    montoTotal: null,
    curency: "",
    idEcheq: "",
    caracter: "",
    document: "",
};

export default RequestCacSummaryBody;
